export const INSPECTION_HERO_IMG =
  "https://images.pexels.com/photos/8293673/pexels-photo-8293673.jpeg?auto=compress&cs=tinysrgb&w=1400";
export const INSPECTION_EXPERIENCE_IMG =
  "https://images.unsplash.com/photo-1674649207083-281c2517ab49?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

export const EXPERTISE = [
  "Residential and investment properties",
  "Fix & flip renovations",
  "Construction project management",
  "Property condition documentation",
  "Construction progress inspections",
  "Real estate acquisition evaluations",
  "Rental property assessments",
];

export const HIGHLIGHTS = [
  { title: "9+ Years in the Field", text: "Hands-on experience across investments, flips, construction and renovation oversight." },
  { title: "Transparent Starting Prices", text: "Every service shows its starting price. Your estimate is itemized before you book." },
  { title: "Easy Online Scheduling", text: "Pick a service, enter your property and choose an available time in minutes." },
  { title: "Detailed Documentation", text: "Clear photo-documented reports you can share with partners, lenders or tenants." },
];

export const BOOKING_STEPS = [
  { n: "01", title: "Choose a service", text: "Compare starting prices and pick the inspection that fits your property." },
  { n: "02", title: "Get your estimate", text: "Enter the property details and see an itemized price instantly." },
  { n: "03", title: "Pick a time", text: "Select an available date and appointment time on the calendar." },
  { n: "04", title: "We confirm", text: "Your request stays pending until our team reviews and confirms it by email." },
];

export const SERVICE_AREAS = [
  "Bucks County",
  "Montgomery County, PA",
  "Dauphin County (Harrisburg)",
  "Northumberland County",
  "Montour County",
  "Columbia County",
  "Snyder County",
  "Union County",
  "Schuylkill County",
  "Luzerne County",
  "Lycoming County",
  "Carbon County",
];

export const CUSTOMER_TYPES = ["Homeowner", "Buyer", "Investor", "Realtor", "Landlord", "Property Manager", "Other"];
export const OCCUPANCY = ["Vacant", "Owner-occupied", "Tenant-occupied", "Under renovation", "Unknown"];
